import SvgIcon from "@mui/material/SvgIcon";

function TikTokIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M12.225 2c.301 1.964 1.85 3.502 3.814 3.79v2.06a6.035 6.035 0 0 1-1.746-.274v5.306a4.982 4.982 0 1 1-4.982-4.982c.198 0 .392.013.582.039v2.128a2.861 2.861 0 1 0 2.861 2.861V2h.47z" />
    </SvgIcon>
  );
}
export default TikTokIcon;
